import { combineReducers } from 'redux';

import createPriceOfferReducer from './CreatePriceOffer/createPriceOfferSlice';
import singlePriceOfferReducer from './SinglePriceOffer/singlePriceOfferSlice';

export default combineReducers({
  createPriceOffer: createPriceOfferReducer,
  singlePriceOffer: singlePriceOfferReducer,
});
